import React, {Dispatch, SetStateAction, useContext} from "react"
import Typography from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import LayoutContext from "../../../context/LayoutContext"
import {QuizzContext} from "../../../context/QuizzContext"

type Props = {
    options: { title?: string, subTitle?: string, imageSrc?:string}[]
    activeIndexes: number[]
    setActiveIndexes: Dispatch<SetStateAction<number[]>>
    isBrands?:boolean
    useBrandTitle?:boolean
}
function RenderQuizOptions({options, activeIndexes, setActiveIndexes, isBrands, useBrandTitle}: Props) {
	const {t} = useTranslation()
	const {isMobile} = useContext(LayoutContext)
	const appendQuizAnswers = index => {
		setActiveIndexes(prev => prev?.includes(index) ? prev.filter(item => item !== index) : [index, ...prev])
	}

	return (
		<>
			{isBrands && options?.length ? options.slice(0, 4).map((option, index) => {
				const letter = String.fromCharCode(65 + index)
				const isActive = activeIndexes.includes(index)
				return <div onClick={() => appendQuizAnswers(index)}
					key={index}
					className={"quizz-option"}
					style={{background: "#FFE9C2", maxWidth: isMobile ? "150px" : "182px", borderRadius: "4px", padding: "12px", minHeight: "56px", border: isActive ? "2px solid #FEC04D" : "2px solid transparent"}}>
					<div className={`p-1 ${isActive ? "bg-primary" : "bg-white"} d-flex align-items-center justify-content-center`}
						style={{borderRadius: "4px", width: "24px", height: "24px"}}>
						<Typography style={{fontSize: "14px"}}
							variant="bodySmBold">{letter}</Typography>
					</div>
					<div className="d-flex flex-column align-items-start justify-content-start">
						{option?.imageSrc ? <img src={option?.imageSrc}
							style={{maxWidth: "72px", height: "auto", objectFit: "cover"}} /> : <Typography variant="bodySmBold">{t(option?.title)}</Typography>}
						{option?.subTitle ? <Typography variant="bodySmBold"
							className="text-secondary">{t(option?.subTitle)}</Typography> : null}
					</div>
				</div>
			}) : options?.length === 0 ? <Typography style={{fontSize: "14px"}}
				variant="bodySmBold">{t("no-results-found")}</Typography> :
				options.map((option, index) => {
					const letter = String.fromCharCode(65 + index)
					const isActive = activeIndexes.includes(index)
					return <div onClick={() => appendQuizAnswers(index)}
						key={index}
						className={"quizz-option"}
						style={{background: "#FFE9C2", borderRadius: "4px", padding: "12px", minHeight: "48px", border: isActive ? "2px solid #FEC04D" : "2px solid transparent"}}>
						<div className={`p-1 ${isActive ? "bg-primary" : "bg-white"} d-flex align-items-center justify-content-center`}
							style={{borderRadius: "4px", width: "24px", height: "24px"}}>
							<Typography style={{fontSize: "14px"}}
								variant="bodySmBold">{letter}</Typography>
						</div>
						<div className="d-flex flex-column align-items-start justify-content-start">
							{option?.imageSrc && !useBrandTitle ? <img src={option?.imageSrc}
								style={{maxWidth: "72px", maxHeight: "30px", height: "auto", objectFit: "contain"}} /> : <Typography variant="bodySmBold">{t(option?.title)}</Typography>}
							{option?.subTitle ? <Typography variant="bodySmBold"
								className="text-secondary">{t(option?.subTitle)}</Typography> : null}
						</div>
					</div>
				})}</>
	)
}

export default RenderQuizOptions
